<div
  class="content"
  gdGap="8px"
  gdColumns="50% auto"
  gdAreas="certificates  CSRs | certificate-authorities  acme-dns"
  gdColumns.lt-lg="auto"
  gdColumns.lt-md="auto"
  gdColumns.lt-sm="auto"
  gdColumns.lt-xs="auto"
  gdAreas.lt-md="certificates | CSRs | certificate-authorities | acme-dns"
  gdAreas.lt-sm="certificates | CSRs | certificate-authorities | acme-dns"
  gdAreas.lt-xs="certificates | CSRs | certificate-authorities | acme-dns"
>
  <div *ngFor="let card of cards" class="certificate-tables" [gdArea]="card.name">
    <ix-conf-table fxFlex [conf]="card.tableConf"></ix-conf-table>
  </div>
</div>
